import { Button } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import React from 'react';

type Props = {
  onClick: () => void;
  buttonText: string;
  isLoading: boolean;
};

export const ControlCardButton = ({ onClick, buttonText, isLoading }: Props) => {
  const isMobile = useIsMobile();

  return (
    <Button
      style={{ width: isMobile ? 'auto' : 'fit-content' }}
      onClick={onClick}
      variant="primary"
      loading={isLoading}
      size={isMobile ? 44 : 52}
    >
      {buttonText}
    </Button>
  );
};
